import { render, staticRenderFns } from "./UserBan.vue?vue&type=template&id=4728bc64&scoped=true"
import script from "./UserBan.vue?vue&type=script&lang=js"
export * from "./UserBan.vue?vue&type=script&lang=js"
import style0 from "./UserBan.vue?vue&type=style&index=0&id=4728bc64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4728bc64",
  null
  
)

export default component.exports